<template id="editable-column-content">
  <div v-if="isEditing
                  && (scope.row === editing.row)
                  && (scope.column.property === editing.column.property)">
    <div class='container' id='app'>
      <select
        class="form-control"
        multiple="true"
        v-bind:class="{ 'fix-height': multiple === 'true' }"
        v-model="multipleSelections"
        @blur="run"
        @keyup.enter="$emit('enter-input')">
        <option
          v-for="option in options"
          :value="option">
          {{option.name}}
        </option>
      </select>
    </div>
  </div>
  <div v-else>
    <span style="margin-left: 10px">{{  displayMultipleSelections }}</span>
  </div>

</template>
<script>

  export default {
    components: {
    },
    name: "ConditionsMultiSelectDropdown",
    props: ['is-editing', 'scope', 'editing', 'on-blur', 'on-enter', 'property', 'options'],
    data: function () {
      return {
        multipleSelections: [],
        data: null,
        multiple: "true",
      }
    },
    methods: {
      run() {
        this.scope.row.applicantName = this.displayMultipleIds;
        this.$emit('blur-input', {field: this.property, index: this.scope.$index, value: this.scope.row});
        // this.ociLog("run");
        // this.ociLog(this.scope.$index);
        // this.ociLog({field: this.property, index: this.scope.$index, value: this.scope.row[this.property]});
      }
    },
    computed: {
      displayMultipleSelections: {
        get() {
          let obj = '';
          for(let i =0; i< this.multipleSelections.length ; i++){
            if(this.multipleSelections && this.multipleSelections[i].name) {
              if(obj && obj.length>0){
                obj +=', ';
              }
              obj += this.multipleSelections[i].name.toString();
            }
          }
          return obj;
        }
      },
      displayMultipleIds: {
        get() {
          let obj = '';
          for(let i =0; i< this.multipleSelections.length ; i++){
            if(this.multipleSelections && this.multipleSelections[i].id) {
              if(obj && obj.length>0){
                obj +=', ';
              }
              obj += this.multipleSelections[i].id.toString();
            }
          }
          return obj;
        }
      }
    },
    directives: {
      focus: {
        // directive definition
        inserted: function (el) {
          el.focus()
        }
      }
    },
    created() {
    }
  }

</script>

<style scoped>

</style>
